module.exports = __webpack_public_path__ + "img/cart-paid.c4722b72.png";